// services/amountWords.js — сума словом на български, за евро.
// Изнесено от invoicepdf.js (01.09.2026), защото и екранният печат
// (src/invoices/print.js) го ползва — там викането на несъществуваща
// функция гърмеше целия бутон „Печат". Ползва се от PDF-а и от Vite.

const ONES = ['нула', 'един', 'два', 'три', 'четири', 'пет', 'шест', 'седем', 'осем', 'девет'];
const TEENS = ['десет', 'единадесет', 'дванадесет', 'тринадесет', 'четиринадесет', 'петнадесет', 'шестнадесет', 'седемнадесет', 'осемнадесет', 'деветнадесет'];
const TENS = ['', '', 'двадесет', 'тридесет', 'четиридесет', 'петдесет', 'шестдесет', 'седемдесет', 'осемдесет', 'деветдесет'];
const HUNDREDS = ['', 'сто', 'двеста', 'триста', 'четиристотин', 'петстотин', 'шестстотин', 'седемстотин', 'осемстотин', 'деветстотин'];

function unitW(o, lf) { if (lf && o === 1) return lf.one; if (lf && o === 2) return lf.two; return ONES[o]; }
function group(n, lf) {
  const c = []; const h = Math.floor(n / 100), rem = n % 100;
  if (h) c.push(HUNDREDS[h]);
  if (rem >= 10 && rem <= 19) c.push(TEENS[rem - 10]);
  else { const t = Math.floor(rem / 10), o = rem % 10; if (t >= 2) c.push(TENS[t]); if (o) c.push(unitW(o, lf)); }
  return c;
}
function joinC(c) { if (c.length <= 1) return c.join(''); return c.slice(0, -1).join(' ') + ' и ' + c[c.length - 1]; }
function words(n, lf) {
  n = Math.floor(n);
  if (n === 0) return 'нула';
  const th = Math.floor(n / 1000), rest = n % 1000;
  let out = '';
  if (th) out = th === 1 ? 'хиляда' : joinC(group(th, { one: 'една', two: 'две' })) + ' хиляди';
  if (rest) { const rc = joinC(group(rest, lf)); out = out ? out + ' ' + rc : rc; }
  return out.trim();
}

// „Сто двадесет евро и нула евроцента" — само за евро; заварен документ в
// друга валута минава без словом (по-добре липсващ ред от грешна дума).
function amountInWords(total) {
  const neg = total < 0;
  const v = Math.abs(Number(total) || 0);
  const whole = Math.floor(v + 1e-9);
  const cents = Math.round((v - whole) * 100);
  let s = words(whole, { one: 'едно', two: 'две' }) + ' евро и ' + words(cents, { one: 'един', two: 'два' }) + (cents === 1 ? ' евроцент' : ' евроцента');
  if (neg) s = 'минус ' + s;
  return s.charAt(0).toUpperCase() + s.slice(1);
}

module.exports = { amountInWords };
